<template>
  <MiFormItem
    :class="[
      'form-time-picker',
      {
        'form-time-picker_in-column': props.inColumn,
        'form-time-picker_only-value': props.onlyValue && props.disabled,
        'form-time-picker_in-line-space-between':
          !props.inColumn && !!props.label && props.spaceBetween,
      },
    ]"
    :error="errorMessage"
    :label="props.label"
    :required="required">
    <div v-if="props.onlyValue && props.disabled">{{ value }}</div>
    <MiTimePicker
      v-else
      v-model="value"
      :arrow-control="true"
      :disabled="props.disabled"
      :value-format="valueFormat"
      :format="format"
      :validate-event="false"
      :placeholder="props.placeholder || $t('Base.SetTime')"
      :picker-options="timePickerOptions"
      @change="$emit('change')" />
  </MiFormItem>
</template>

<script lang="ts" setup>
import { useField } from 'vee-validate';

import { MiTimePicker, MiFormItem } from '~shared/ui';

type Props = {
  onlyValue?: boolean;
  inColumn?: boolean;
  spaceBetween?: boolean;
  disabled?: boolean;
  required?: boolean;
  fieldName: string;
  label?: string;
  placeholder?: string;
  format?: string;
  valueFormat?: string;
};

const props = withDefaults(defineProps<Props>(), {
  onlyValue: false,
  inColumn: true,
  spaceBetween: false,
  disabled: false,
  required: false,
  label: '',
  placeholder: '',
  format: 'HH:mm',
  valueFormat: 'HH:mm',
});

const timePickerOptions = {
  start: '06:00',
  end: '21:00',
};

// eslint-disable-next-line vue/no-setup-props-destructure
const { value, errorMessage, setValue } = useField<string>(props.fieldName);

defineExpose({
  value,
  setValue,
});
</script>

<style lang="scss" src="./index.scss" />
<i18n src="@/locales/base.locales.json" />
